module.exports = __webpack_public_path__ + "img/emptyAdverst.f384621b.svg";